<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    :modal="false"
    center
    :modal-append-to-body="false"
    width="400px"
    style="width: 540px;height: 550px;left:62%;"
  >
    <section v-loading="getDetailLoading" class="dialog-content">
      <section>
        <div class="rowItem"><span>车牌号码：</span><span class="primary cur" @click="toCarDetail(originData)">{{originData.plateNumber}}</span>
        </div>
        <div class="rowItem"><span>归属部门：</span><span>{{originData.orgName}}</span>
        </div>
        <div class="rowItem"><span>车辆状态：</span><span>{{originData.vehicleStateJt808Name}} {{originData.vehicleStateJt808!==2?originData.vehicleStateVulaeJt808Str:''}}</span>
        </div>
        <div class="rowItem"><span>实时位置：</span><span>{{originData.vehicleLocationJt808}}</span>
        </div>
        <div class="rowItem"><span>定位时间：</span><span>{{originData.locationTime}}</span>
        </div>
        <div class="rowItem"><span>主驾信息：</span><span  class="primary cur" @click="toDriverDetail(originData,'')">{{originData.driverInformation!=='/'?originData.driverInformation:''}}</span>
        </div>
      </section>
      <span class="vehicleStatusBox" :style="`background:${background}`">
        <span :style="`margin-bottom:${originData.vehicleStateJt808!==2?'8px':''}`">{{originData.vehicleStateJt808Name}}</span>
        <span style="font-size:clamp(0.3rem, 0.489rem + 1.05vw, 0.5rem);text-align: center;">{{originData.vehicleStateJt808!==2?originData.vehicleStateVulaeJt808Str:''}}</span>
      </span>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button type="primary" @click="toTrack(originData)">车辆轨迹</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {queryVehicleMonitorInfo} from 'api/index';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      background: '',
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.getDetailLoading = true;
      const res = await queryVehicleMonitorInfo({
        plateNumber: item.plateNumber,
      });
      this.originData = res.items[0];
      switch (this.originData.vehicleStateJt808) {
        case 3:
          this.background = '#000';
          break;
        case 2:
          this.background = '#0088FF';
          break;
        case 1:
          this.background = '#008800';
          break;
        default:
          this.background = '';
      }
      this.getDetailLoading = false;
    },
    toDriverDetail (item, type) {
      this.dialogFormVisible = false; // 打开弹窗
      this.jump({
        label: '查看司机档案',
        url: `/manage/archives/driver/archives/detail?id=${item.driverUserId}&type=${type}`,
        full: true,
      });
    },
    toCarDetail (item) {
      this.dialogFormVisible = false;
      const type = 'detail';
      this.jump({
        label: `查看车辆-${item.plateNumber}`,
        url: `/manage/car/archives/my/detailRecord?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass}&type=${type}`,
        full: true,
      });
    },
    toTrack (item) {
      this.dialogFormVisible = false;
      let plateNumber = encodeURI(item.plateNumber);
      this.jump({
        label: `轨迹查询-${item.plateNumber}`,
        url: `/manage/operate/track/track?plateNumber=${plateNumber}`,
        full: true,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.rowItem{
  font-size: 16px;
  margin: 10px 10px;
}
.dialog-content{
  display: flex;
  justify-content: space-between;
}
.vehicleStatusBox{
  width: 100px;
  height: 100px;
  border-radius: 50%;
  color: #fff;
  font-weight: 600;
  background: rgb(0, 0, 0);
  display: flex;
  align-items: center;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  flex: 0 0 auto;

}
</style>

